import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff } from 'lucide-react';

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowBanner(true);
      setTimeout(() => setShowBanner(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowBanner(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showBanner) return null;

  return (
    <div className={`fixed bottom-4 right-4 z-50 px-4 py-2 rounded-md shadow-lg flex items-center gap-2 transition-all duration-500 ${isOnline ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}>
      {isOnline ? (
        <>
          <Wifi size={18} />
          <span>Back online</span>
        </>
      ) : (
        <>
          <WifiOff size={18} />
          <span>You're offline. Some features may be limited.</span>
        </>
      )}
    </div>
  );
};

export default NetworkStatus; 